export enum SocialIconType {
  Facebook,
  Google,
}
